import { render, staticRenderFns } from "./PrizeSaverDraws.vue?vue&type=template&id=db1e509e&scoped=true&"
import script from "./PrizeSaverDraws.vue?vue&type=script&lang=js&"
export * from "./PrizeSaverDraws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1e509e",
  null
  
)

export default component.exports